import type { AvailableGameCatalogEntry } from '../../catalog-entry.js';
import { spadesDescriptor } from './descriptor.js';

export const spadesCatalogEntry = {
  descriptor: spadesDescriptor,
  availability: 'production',
  load: async () => (await import('./game.js')).spadesGeneratorDefinition,
} satisfies AvailableGameCatalogEntry;
